import { NetworkService } from "../../../../services/networkService";

const updateStaffCapping = async (agencyId, values) => {
  let response = await NetworkService.patch(`api/agencies/${agencyId}/update_staff_cap`, values);
  return response;
};
export default updateStaffCapping;
